/**
 * @file All pages list with filters and last-modified columns.
 */
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { Suspense, useMemo } from "react";
import { PagesDirectory } from "@/components/pages/PagesDirectory";
import { useAuth } from "@/lib/auth-context";
import { canManageContent } from "@/lib/permissions";

export function PagesListPage() {
  const { user } = useAuth();
  const canCreate = useMemo(() => canManageContent(user?.roles), [user?.roles]);

  return (
    <Suspense
      fallback={
        <Typography variant="body2" color="text.secondary">
          Loading pages…
        </Typography>
      }
    >
      <PagesDirectory
        title="All pages"
        actions={
          canCreate ? (
            <Button component={Link} to="/dashboard/pages/new" variant="contained">
              New page
            </Button>
          ) : null
        }
      />
    </Suspense>
  );
}
